import React from 'react';
import { Star } from 'lucide-react';
export function ReviewsHero() {
  return <section className="bg-ink py-20 text-center px-4" data-id="element-2931">
      <h1 className="text-5xl md:text-6xl text-white mb-6" data-id="element-2932">
        Trusted by Local Families
      </h1>
      <p className="text-xl text-gray-warm max-w-2xl mx-auto mb-8" data-id="element-2933">
        Real reviews from parents and students who train at Storm Taekwondo in
        Farmington Hills.
      </p>
      <div className="inline-flex items-center gap-3 bg-charcoal border border-storm-red/30 rounded-full px-6 py-3" data-id="element-2934">
        <div className="flex items-center gap-1" data-id="element-2935">
          {Array.from({
          length: 5
        }).map((_, i) => <Star key={i} className="w-5 h-5 text-gold" fill="currentColor" data-id="element-2936" />)}
        </div>
        <span className="text-white font-bold" data-id="element-2937">5.0 Rating</span>
        <span className="text-gray-warm" data-id="element-2938">|</span>
        <span className="text-gray-warm" data-id="element-2939">From 201 Reviews</span>
      </div>
    </section>;
}